/* global module */

/**
 * View Controllers                                                                                                   View Controllers
 * ************************************************************************************************************************************
 */
var angular = require("angular");
var app = angular.module("learn-controllers", []);

require("./controllers/add-users-csv");
require("./controllers/dashboard");
require("./controllers/edit-access-profile");
require("./controllers/edit-article");
require("./controllers/edit-badge");
require("./controllers/edit-assessment");
require("./controllers/edit-event");
require("./controllers/edit-file");
require("./controllers/edit-group");
require("./controllers/edit-imported-content");
require("./controllers/edit-journey");
require("./controllers/edit-multi-session-workshop");
require("./controllers/edit-poll");
require("./controllers/edit-presentation");
require("./controllers/edit-quiz");
require("./controllers/edit-scorm");
require("./controllers/edit-survey");
require("./controllers/edit-track");
require("./controllers/edit-video");
require("./controllers/edit-workflow");
require("./controllers/edit-workshop");
require("./controllers/edit-report");
require("./controllers/manager-grader");
require("./controllers/overview-admin");
require("./controllers/overview-assessments");
require("./controllers/overview-assignments");
require("./controllers/overview-content");
require("./controllers/overview-journeys");
require("./controllers/overview-polls");
require("./controllers/overview-users");
require("./controllers/overview-reports");
require("./controllers/overview-badges");
require("./controllers/overview-workshops");
require("./controllers/overview-settings");
require("./controllers/overview-surveys");
require("./controllers/pre-cooked");
require("./controllers/saml-errors");
require("./controllers/assignment-calendar");

/**
 * Header Controller is the <head> controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.controller("headerController", [
  "Application", "Authorization",
  function (Application) {
    var self = this;
    self.layout = "default";
    self.initialize = function () {
      self.layout = Application.LAYOUT;
      self.theme = "topnav-theme";
      self.assetBaseUrl = Application.assetCdnUrl;
      self.publicImageUrl = Application.publicImageUrl;
    };
    self.initialize();
  },
]);
/**
 * Body Controller is the <body> controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {$scope} $scope injected to gain access to the event listener model for views
 */
app.controller("bodyController", [
  "Application", 
  "Authorization",
  "AccessHelper",
  "$scope",
  function (Application, Authorization, AccessHelper, $scope) {
    var self = this;
    var engageAttempts = 0;
    function setEngage() {
      if (engageAttempts >= 15) {
        return;
      }
      engageAttempts++;
      if (
        Application &&
        Authorization.getAuthToken() &&
        Authorization.getAuthToken().company
      ) {
        self.engage = Authorization.getAuthToken().company.engage;
      } else {
        setTimeout(function () {
          setEngage();
        }, 100);
      }
    }

    setEngage();

    self.usercontextvisibility = false;

    self.setusercontextvisibility = (status) =>{
      self.usercontextvisibility = status;
    }

    self.mobileNavVisible = false;

    self.hasValidAuthToken = Authorization.hasValidAuthToken;

    // Check if sync is required
    Authorization.getAuthToken();

    if (Authorization.hasValidAuthToken() && Application.access.sync && Application.navigation.getPath() !== "/oauth-transition") {
      // Sync should only occur when pulling authtoken from local storage
      Application.access.sync = false;
      AccessHelper.manualSessionData().$promise;
    }

    $scope.$on("$locationChangeStart", function (event, next) {
      var nextPath = next.slice(next.indexOf("#") + 1);

      if (nextPath.indexOf("?") !== -1) {
        nextPath = nextPath.slice(0, nextPath.indexOf("?"));
      }

      if (Application.navigation.isRouteSecure(nextPath) && !Authorization.hasValidAuthToken()) {
        Application.navigation.goToSignIn();
      }
    });



    if (Application.CUSTOMFONT) {
      var script = document.createElement("script");
      script.innerHTML =
        '!function(e){var t,a={kitId:"iji5ynt",scriptTimeout:3e3,async:!0},i=e.documentElement,c=setTimeout(function(){i.className=i.className.replace(/\bwf-loading\b/g,"")+" wf-inactive"},a.scriptTimeout),n=e.createElement("script"),s=!1,o=e.getElementsByTagName("script")[0];i.className+=" wf-loading",n.src="https://use.typekit.net/"+a.kitId+".js",n.async=!0,n.onload=n.onreadystatechange=function(){if(t=this.readyState,!(s||t&&"complete"!=t&&"loaded"!=t)){s=!0,clearTimeout(c);try{Typekit.load(a)}catch(e){}}},o.parentNode.insertBefore(n,o)}(document);';
      document.body.appendChild(script);
    }
  },
]);
/**
 * Secure Controller is a multi-use generic controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Service} $translate Angular-Translate Service
 */
app.controller("secureController", [
  "Application", 
  "Authorization",
  "i18n",
  function (Application, Authorization, i18n) {
    var self = this;
    self.authtoken = Authorization.getAuthToken();
    self.contentId = Application.navigation.getRouteParameters().id;
    self.learn = "Text";
    self.initialize = function () {
      if (Authorization.hasValidAuthToken()) {
        self.user = self.authtoken.user;
        if (!Application.navigation.isRoute("/home")) {
          Application.smartbar.hideCategories();
          Application.smartbar.hideSearch();
        }
        return;
      }
      if (Application.navigation.isRouteSecure()) {
        Application.navigation.goToSignIn();
      }
    };
    self.swapLanguage = function (lang) {
      i18n.language(lang);
    };
    self.language = "choose below";
    self.home = function () {
      Application.navigation.goToHome();
    };
    self.explore = function () {
      Application.navigation.goTo("/explore");
    };
    self.view = function (content, id) {
      Application.navigation.goTo("/view/" + content + "/" + id);
    };
    self.edit = function (content, id) {
      Application.navigation.goTo("/edit/" + content + "/" + id);
    };
    self.signout = function () {
      Authorization.signout();
    };
    self.comments = false;
    self.allowComments = function () {
      self.comments = true;
    };
    self.initialize();
  },
]);
/**
 * Public Controller is a multi-use generic controller for public resources
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.controller("publicController", [
  "Application", 
  "Authorization",
  function (Application, Authorization) {
    var self = this;
    var preRedirect = Application.navigation.getPath();
    self.initialize = function () {
      if (
        preRedirect !== "/oauth-transition" &&
        preRedirect !== "/saml-transition" &&
        Authorization.hasValidAuthToken()
      ) {
        Application.navigation.goToHome();
        return;
      }
    };
    self.initialize();
  },
]);
/**
 * Edit Article Controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {resource} articles injected to gain access to the Articles resource
 */
app.controller("editArticleController", [
  "Application", 
  "Authorization",
  "articles",
  "$translate",
  function (Application, Authorization, articles, $translate) {
    var self = this;
    self.authtoken = Authorization.getAuthToken();
    self.user = self.authtoken.user;
    self.getError = Application.notifications.getError;
    self.getSuccess = Application.notifications.getSuccess;
    self.article = {};

    self.initialize = function () {
      var routeParameters = Application.navigation.getRouteParameters();
      if (!routeParameters.id) {
        console.log("No id specified");
        Application.navigation.goToHome();
        return;
      }

      articles.get(
        { subresource: routeParameters.id },
        function (data) {
          self.article = data;
        },
        function (error) {
          console.log("Error occured getting article ", routeParameters.id, error);
          Application.notifications.setError(self.translations["modules.notifications.unableToGetArticle"]);
        }
      );

      if (Authorization.hasValidAuthToken()) {
        return;
      }
      if (Application.navigation.isRouteSecure()) {
        Application.navigation.goToSignIn();
      }
    };

    $translate(["modules.notifications.unableToGetArticle"]).then(function (translations) {
      self.translations = translations;
      self.initialize();
    });
  },
]);
/**
 * Browserify Module export
 * @type angular module @exp;app
 */
module.exports = app;
